/* istanbul ignore file */

import Homepage from '../pages/Homepage';

const base = '/bukareksa';

const routes = [
  {
    path: `${base}/`,
    name: 'Homepage',
    component: Homepage,
  },
];

export default routes;
